module.exports = __webpack_public_path__ + "icons/original/large/large-d6.3707649a76849867b0067b33cee2f45a.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-d6.png
// module id = q9gS
// module chunks = app